import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppStoreButtons"] */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalLink"] */ "/app/src/components/Clickables/ExternalLink/ExternalLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppOnlyPill"] */ "/app/src/components/Clickables/Pill/AppOnlyPill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRCode"] */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/ShopLandingPage/assets/allCatchesDesktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/ShopLandingPage/assets/allCatchesMobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/ShopLandingPage/assets/heroDesktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/ShopLandingPage/assets/heroMobile.png");
;
import(/* webpackMode: "eager", webpackExports: ["ShopLandingFeatureLink"] */ "/app/src/views/ShopLandingPage/components/ShopLandingFeatureLink.tsx");
